<template>
  <datatable :type="'contacts'" :rowData="contacts" :loadingMessage="loadingMessage" :noRowsMessage="noRowsMessage" :columns="columns"
             :paginationSize="50"></datatable>
</template>
<script>
import datatable from "datatables/datatable";

export default {
  name: 'all_contacts',
  components: {
    datatable
  },
  data() {
    return {
      contacts: null,
      loadingMessage: 'Loading Contacts...',
      noRowsMessage: 'No Contacts Found',
      columns: [
        {headerName: 'Company', field: 'company_name', minWidth: 175, pinned: 'left'},
        {headerName: 'Name', minWidth: 175, pinned: 'left', field: 'full_name'},
        {headerName: 'Job Title', minWidth: 140, field: 'job_title'},
        // {headerName: 'Last Contacted (Note)', minWidth: 190, valueGetter: this.last_contacted_value_getter},
        {headerName: 'Work Landline', field: 'work_landline', minWidth: 105},
        {headerName: 'Work Mobile', field: 'work_mobile', minWidth: 105},
        {headerName: 'Personal Landline', field: 'personal_landline', minWidth: 105},
        {headerName: 'Personal Mobile', field: 'personal_mobile', minWidth: 105},
        {headerName: 'Email', field: 'w_email', minWidth: 200},
        // {headerName: 'Office Work Address', minWidth: 300, valueGetter: this.office_work_address_vg},
      ]
    }
  },
  beforeMount() {
    this.$bus.$on('table::reload', ($event) => {
      if ($event.table === 'all_contacts' && ($event.type === 'store' || $event.type === 'update')) {
        this.get_contacts();
      }
    });
  },
  mounted() {
    this.get_contacts();
  },
  methods: {
    get_contacts() {
      axios.get(this.crmApiPath + 'contact/index').then(contacts => this.contacts = contacts.data).catch(error => console.log(error.response));
    },
    contact_name_vg(params) {
      return params.data.person.first_name + ' ' + params.data.person.surname;
    },
    last_contacted_value_getter(params) {
      if (params.data.last_note !== null && params.data.last_note.length > 0) {
        return this.$options.filters.formatDateTime(params.data.last_note[0].updated_at);
      }
      else {
        return '';
      }
    },
    job_title_vg(params) {
      if (params.data.rel_profile.job_title_id !== null) {
        return params.data.rel_profile.job_title.job_title;
      }
    },
    office_work_address_vg(params) {
      if (params.data.office_work_address !== null) {
        return params.data.office_work_address.full;
      }
    }
  }
}
</script>
